// Copyright 2020 The MathWorks, Inc.

define([
  './MainPane'
], (MainPane) => {
  return {
    start: () => {
      const mainPane = new MainPane();
      mainPane.placeAt(document.querySelector('#main'));
      mainPane.startup();
    }
  };
});
